// extracted by mini-css-extract-plugin
export default {"deletePaymentMethodButton":"vReL9Y1gWJ4wpvwdmy17"};